import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "upload",
  "use": "upload-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 21\" id=\"upload\"><title>upload</title><g id=\"upload__visibility\"><path d=\"M15.37,8.14l-4.46-5a.56.56,0,0,0-.82,0l-4.46,5a.48.48,0,0,0,0,.7.49.49,0,0,0,.7,0l3.63-4V14a.5.5,0,0,0,1,0V4.78l3.63,4A.49.49,0,0,0,15,9a.46.46,0,0,0,.33-.13A.48.48,0,0,0,15.37,8.14Z\" /><path d=\"M16.5,18H4.5a.5.5,0,0,1,0-1h12a.5.5,0,0,1,0,1Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/upload.svg
// module id = QOvy
// module chunks = 4